/** コインの表裏（core のコイントスの結果＝ Duel.TossCoin の返り: 1 = 表 / 0 = 裏。Issue #857）。登録の選び直しの画面が使う。ほかの日本語の文はサーバーの input（Issue #667） */
export const COIN_LABEL = { 1: '表', 0: '裏' };
